import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { bodyStyles } from './Body.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * The Body component renders body typography with consistent styling.
 * It supports different sizes and can render as different HTML elements via the 'as' prop.
 */
const Body = (_a) => {
    var { size, inverse = false, as = "span", className, children } = _a, props = __rest(_a, ["size", "inverse", "as", "className", "children"]);
    // Get base styles for body variant
    const { base: baseClasses, leading: leadingClasses } = bodyStyles({
        inverse,
        size,
    });
    // Combine base classes with user-provided className
    const finalClassName = cn(baseClasses(), leadingClasses(), className);
    // Create a polymorphic component that renders the correct element
    const Component = as;
    return (jsx(Component, Object.assign({ className: finalClassName }, props, { children: children })));
};

export { Body };
